import React from 'react'

import Passage from './Passage'

export type PassageRawProps = {
  questionId: number
  number: number
  text: string
  image: string
}

export type PassageProps = {
  id: number
  number: string
  text: string
  image: string
  questionId: number
}

export type PassageCompProps = Pick<PassageRawProps, 'text' | 'image'>

export type PassagesCompProps = {
  passages: PassageProps[]
}

export default function Passages({ passages }: PassagesCompProps) {
  if (passages?.length) {
    return (
      <div className={'mt-6 sm:mt-9 p-3 sm:p-6 border border-eaeaea'}>
        {passages.map((passage) => {
          const props = { text: passage.text, image: passage.image }
          return <Passage key={passage.id} {...props} />
        })}
      </div>
    )
  }
  return <></>
}
